import { fromJS } from 'immutable';
import { createAction, handleActions } from 'redux-actions';
import api from '../../utils/api';

export const initialState = fromJS({
  mailboxes: [],
  articles: [],
  isLoading: true,
});

// const
export const GET_MAILBOXES = 'mailbox/GET_MAILBOXES';
export const GET_MAILBOX_ARTICLES = 'mailbox/GET_MAILBOX_ARTICLES';

// action creators
export const getMailboxes = createAction(
  GET_MAILBOXES,
  api.mailbox.getMailboxes,
);

export const getMailboxArticles = createAction(
  GET_MAILBOX_ARTICLES,
  api.mailbox.getMailboxArticles,
);

// reducer
const mailboxReducer = handleActions(
  {
    [`${GET_MAILBOXES}_REQUEST`]: (state) => state.set('isLoading', true),

    [`${GET_MAILBOXES}_SUCCESS`]: (state, { payload }) =>
      state
        .set('mailboxes', payload.get('data').get('mailboxes'))
        .set('isLoading', false),

    [`${GET_MAILBOXES}_ERROR`]: (state) => state.set('isLoading', false),

    // Supplementary KB content — intentionally does NOT touch `isLoading`
    // (that flag gates the full-page spinner). Bare-array endpoint, so
    // `payload.get('data')` is already the Immutable List of article Maps.
    [`${GET_MAILBOX_ARTICLES}_SUCCESS`]: (state, { payload }) =>
      state.set('articles', payload.get('data')),
  },
  initialState,
);

export default mailboxReducer;
